<template>
  <div class="container">
    <img class="mt-4" :src="heroImage" alt="" />
    <div class="mt-4 text-describe">
      {{ $t(introTextKey) }}<br />
      {{ $t("sendEmail.tip2") }}
    </div>
    <div class="card-box">
      <div class="title">{{ $t("sendEmail.enter_address") }}</div>
      <input
        v-model="emailValue"
        :placeholder="$t('General.Email')"
        :class="{ errorinput: emailError }"
        class="email-input"
        type="text"
      />
      <div v-if="emailError" class="tips error-tip">{{ errorText }}</div>
      <div class="tips">
       {{ $t("sendEmail.confidential") }}
      </div>
      <div class="button" @click="sendEmail">{{ $t("General.Send") }}</div>
    </div>
    <div class="or">
      <div class="or-line"></div>
      <div class="or-text">{{ $t("General.or") }}</div>
      <div class="or-line"></div>
    </div>
    <div class="card-box">
      <i18n path="sendEmail.open_link" tag="div" class="title">
        <span class="url">drfone.wondershare.com</span>
      </i18n>
      <img class="mt-4" src="images/website.png" alt="" />
      <div class="button" @click="goDonePage">{{ $t("General.Done") }}</div>
    </div>
  </div>
</template>
<script>
import request from "../../utils/Request";
export default {
  data() {
    return {
      emailValue: "",
      emailError: false,
      errorText: "",
      isIos: false,
      feature: "",
      requestedLang: ""
    };
  },
  computed: {
    isRepair() {
      return this.feature === "repair";
    },
    isCheck() {
      return this.feature === "check";
    },
    heroImage() {
      return this.isRepair ? "images/repair.png" : "images/unlock.png";
    },
    introTextKey() {
      if (this.isCheck) {
        return "sendEmail.check_tip1";
      }
      return this.isRepair ? "sendEmail.repair_tip1" : "sendEmail.tip1";
    },
    emailEndpoint() {
      if (this.isRepair) {
        return "/v2/user/send-repair-desktop-solution";
      }
      return this.isCheck
        ? "/v2/user/send-check-desktop-solution"
        : "/v2/user/send-desktop-solution";
    }
  },
  watch: {
    emailValue() {
      this.emailError = false;
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("os_name")) {
      this.isIos = urlParams.get("os_name").toLowerCase() === "ios";
    }
    this.feature = (urlParams.get("feature") || "").toLowerCase();
    this.requestedLang = urlParams.get("lang") || "";
  },
  methods: {
    sendEmail() {
      this.emailError = false;
      if (!this.emailValue) {
        this.emailError = true;
        this.errorText = this.$t("sendEmail.enter_address");
        return;
      }
      request({
        baseURL: process.env.VUE_APP_USER_API_URL,
        url: this.emailEndpoint,
        method: "get",
        params: {
          email: this.emailValue,
          lang: this.requestedLang || this.$i18n.locale || "en"
        }
      })
        .then(res => {
          if (res.code === 204000) {
            this.emailError = true;
            this.errorText = this.$t("sendEmail.enter_correct_address");
            return;
          } else if (res.code === 200) {
            this.goToFeaturePage("sent");
          }
        })
        .finally(() => {
          if (this.isIos && window.webkit && window.webkit.messageHandlers) {
            window.webkit.messageHandlers.drfoneApp.postMessage({
              msgType: "ClickSendEmail",
              msgData: {}
            });
          } else if (window.android) {
            window.android.click(
              this.isRepair
                ? "sendRepairEmail"
                : this.isCheck
                ? "sendCheckEmail"
                : "sendEmail"
            );
          }
        });
    },
    goDonePage() {
      this.goToFeaturePage("done");
      if (this.isIos) {
        if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.drfoneApp.postMessage({
            msgType: "ClickOpenHome",
            msgData: {}
          });
        }
      } else {
        if (window.android) {
          window.android.click(
            this.isRepair
              ? "openRepairHome"
              : this.isCheck
              ? "openCheckHome"
              : "openHome"
          );
        }
      }
    },
    goToFeaturePage(page) {
      const query = {
        os_name: this.isIos ? "ios" : "android"
      };
      if (this.feature) {
        query.feature = this.feature;
      }
      if (this.requestedLang || this.$i18n.locale) {
        query.lang = this.requestedLang || this.$i18n.locale;
      }
      this.$router.push({ path: `/${page}`, query });
    }
  }
};
</script>

<style>
#app {
  background-color: #f9fbfe;
}
</style>

<style scoped>
.mt-4 {
  margin-top: 16px !important;
}

.container {
  max-width: 375px;
  padding: 16px 16px 36px;

  /* font-family: SF Pro Text; */
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.40799999237060547px;
}

.text-describe {
  color: #46464b;
}

.card-box {
  background-color: #fff;
  margin-top: 16px;
  padding: 16px;
  border-radius: 16px;
}

.title {
  font-weight: 500;
  color: #232326;
}

.email-input {
  margin-top: 12px;
  width: 100%;
  height: 48px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #9294a04d;
  outline: none;
}

.email-input::placeholder {
  color: #bebec8;
}

.errorinput {
  border: 1px solid #ff4163;
}

.tips {
  margin-top: 4px;
  color: #999;
}

.error-tip {
  font-size: 13px;
  line-height: 15.51px;

  color: #ff4163;
}

.button {
  margin-top: 24px;
  height: 48px;
  padding: 14px 8px;
  border-radius: 100px;
  background: #0084ff;

  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.23999999463558197px;
  text-align: center;
  color: #fff;
}

.button:active {
  background: #0071f5;
}

.or {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
}

.or-line {
  width: 100%;
  height: 1px;
  background: linear-gradient(
    to left,
    transparent 0%,
    transparent 50%,
    #c7c7c7 50%,
    #c7c7c7 100%
  );
  background-size: 8px 1px;
  background-repeat: repeat-x;
}

.or-text {
  margin: 0 16px;
  line-height: 16px;
  color: #c7c7c7;
  flex: none;
}

.url {
  color: #0095ff;
  text-decoration: underline;
}
</style>
